import APP_CONSTANTS from "src/application/shared/app_constants";
import loadCensoredWords from "../loadCensoredWords";

let censored_words_en = new Set([
  "13.",
  "13点",
  "三级片",
  "下三烂",
  "下贱",
  "个老子的",
  "九游",
  "乳",
  "乳交",
  "乳头",
  "乳房",
  "乳波臀浪",
  "交配",
  "仆街",
  "他奶奶",
  "他奶奶的",
  "他奶娘的",
  "他妈",
  "他妈ㄉ王八蛋",
  "他妈地",
  "他妈的",
  "他娘",
  "他马的",
  "你个傻比",
  "你他马的",
  "你全家",
  "你奶奶的",
  "你她马的",
  "你妈",
  "你妈的",
  "你娘",
  "你娘卡好",
  "你娘咧",
  "你它妈的",
  "你它马的",
  "你是鸡",
  "你是鸭",
  "你马的",
  "做爱",
  "傻比",
  "傻逼",
  "册那",
  "军妓",
  "几八",
  "几叭",
  "几巴",
  "几芭",
  "刚度",
  "刚瘪三",
  "包皮",
  "十三点",
  "卖B",
  "卖比",
  "卖淫",
  "卵",
  "卵子",
  "双峰微颤",
  "口交",
  "口肯",
  "叫床",
  "吃屎",
  "后庭",
  "吹箫",
  "塞你公",
  "塞你娘",
  "塞你母",
  "塞你爸",
  "塞你老师",
  "塞你老母",
  "处女",
  "外阴",
  "大卵子",
  "大卵泡",
  "大鸡巴",
  "奶",
  "奶奶的熊",
  "奶子",
  "奸",
  "奸你",
  "她妈地",
  "她妈的",
  "她马的",
  "妈B",
  "妈个B",
  "妈个比",
  "妈个老比",
  "妈妈的",
  "妈比",
  "妈的",
  "妈的B",
  "妈逼",
  "妓",
  "妓女",
  "妓院",
  "妳她妈的",
  "妳妈的",
  "妳娘的",
  "妳老母的",
  "妳马的",
  "姘头",
  "姣西",
  "姦",
  "娘个比",
  "娘的",
  "婊子",
  "婊子养的",
  "嫖娼",
  "嫖客",
  "它妈地",
  "它妈的",
  "密洞",
  "射你",
  "射精",
  "小乳头",
  "小卵子",
  "小卵泡",
  "小瘪三",
  "小肉粒",
  "小骚比",
  "小骚货",
  "小鸡巴",
  "小鸡鸡",
  "屁眼",
  "屁股",
  "屄",
  "屌",
  "巨乳",
  "干x娘",
  "干七八",
  "干你",
  "干你妈",
  "干你娘",
  "干你老母",
  "干你良",
  "干妳妈",
  "干妳娘",
  "干妳老母",
  "干妳马",
  "干您娘",
  "干机掰",
  "干死CS",
  "干死GM",
  "干死你",
  "干死客服",
  "幹",
  "强奸",
  "强奸你",
  "性",
  "性交",
  "性器",
  "性无能",
  "性爱",
  "情色",
  "想上你",
  "懆您妈",
  "懆您娘",
  "懒8",
  "懒八",
  "懒叫",
  "懒教",
  "成人",
  "我操你祖宗十八代",
  "扒光",
  "打炮",
  "打飞机",
  "抽插",
  "招妓",
  "插你",
  "插死你",
  "撒尿",
  "操你",
  "操你全家",
  "操你奶奶",
  "操你妈",
  "操你娘",
  "操你祖宗",
  "操你老妈",
  "操你老母",
  "操妳",
  "操妳全家",
  "操妳妈",
  "操妳娘",
  "操妳祖宗",
  "操机掰",
  "操比",
  "操逼",
  "放荡",
  "日他娘",
  "日你",
  "日你妈",
  "日你老娘",
  "日你老母",
  "日批",
  "月经",
  "机八",
  "机巴",
  "机机歪歪",
  "杂种",
  "浪叫",
  "淫",
  "淫乱",
  "淫妇",
  "淫棍",
  "淫水",
  "淫秽",
  "淫荡",
  "淫西",
  "湿透的内裤",
  "激情",
  "灨你娘",
  "烂货",
  "烂逼",
  "爛",
  "狗屁",
  "狗日",
  "狗狼养的",
  "玉杵",
  "王八蛋",
  "瓜娃子",
  "瓜婆娘",
  "瓜批",
  "瘪三",
  "白烂",
  "白痴",
  "白癡",
  "祖宗",
  "私服",
  "笨蛋",
  "精子",
  "老二",
  "老味",
  "老母",
  "老瘪三",
  "老骚比",
  "老骚货",
  "肉壁",
  "肉棍子",
  "肉棒",
  "肉缝",
  "肏",
  "肛交",
  "肥西",
  "色情",
  "花柳",
  "荡妇",
  "賤",
  "贝肉",
  "贱B",
  "贱人",
  "贱货",
  "贼你妈",
  "赛你老母",
  "赛妳阿母",
  "赣您娘",
  "轮奸",
  "迷药",
  "逼",
  "逼样",
  "野鸡",
  "阳具",
  "阳萎",
  "阴唇",
  "阴户",
  "阴核",
  "阴毛",
  "阴茎",
  "阴道",
  "阴部",
  "雞巴",
  "靠北",
  "靠母",
  "靠爸",
  "靠背",
  "靠腰",
  "驶你公",
  "驶你娘",
  "驶你母",
  "驶你爸",
  "驶你老师",
  "驶你老母",
  "骚比",
  "骚货",
  "骚逼",
  "鬼公",
  "鸡8",
  "鸡八",
  "鸡叭",
  "鸡吧",
  "鸡奸",
  "鸡巴",
  "鸡芭",
  "鸡鸡",
  "龟儿子",
  "龟头",
  "𨳒",
  "陰莖",
  "㞗",
  "尻",
  "𨳊",
  "鳩",
  "𡳞",
  "𨶙",
  "撚",
  "𨳍",
  "柒",
  "閪",
  "仆街",
  "咸家鏟",
  "冚家鏟",
  "咸家伶",
  "冚家拎",
  "笨實",
  "粉腸",
  "屎忽",
  "躝癱",
  "你老闆",
  "你老味",
  "你老母",
  "硬膠",
]);

if (!censored_words_en.keys.length) {
  async () => {
    try {
      censored_words_en = await loadCensoredWords(
        APP_CONSTANTS.CENSORED_WORDS_FETCH_URLS.ZH
      );
    } catch (error) {
      throw new Error(`❌ Error loading censored words [ZH]! ${error}`);
    }
  };
}

export default censored_words_en;
